export default "__VITE_ASSET__Y_M7fupX__"